import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { WINDOW_TOKEN } from "@kno2/core/browser";
import { RedirectService } from "@kno2/core/routing";
import { SessionService } from "@kno2/core/session";
import { SessionStorageService } from "@kno2/core/storage";
import { IdProofingService } from "@kno2/data-access/id-proofing";
import { ID_PROOFING_ERROR_STORAGE_KEY } from "./id-proofing.constants";

@Component({
    selector: "kno2-id-proofing-callback",
    imports: [],
    template: `
        <div class="callback-screen">
            <div class="callback-card">
                <div
                    class="spinner-border text-primary"
                    role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <h2 class="callback-title">Validating your identity</h2>
                <p class="callback-subtitle">Hang tight - we're confirming your information with CLEAR. This usually takes just a few seconds.</p>
            </div>
        </div>
    `,
    styleUrl: "./id-proofing-callback.component.scss"
})
export class IdProofingCallbackComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);
    private readonly window = inject(WINDOW_TOKEN);
    private readonly idProofingService = inject(IdProofingService);
    private readonly sessionStorageService = inject(SessionStorageService);
    private readonly redirectService = inject(RedirectService);
    private readonly sessionService = inject(SessionService);

    public async ngOnInit(): Promise<void> {
        try {
            await this.processCallback();
        } finally {
            this.redirectService.getRedirectUrl(true);
            this.window.location.href = "/";
        }
    }

    private async processCallback(): Promise<void> {
        const queryParams = this.route.snapshot.queryParamMap;
        const state = queryParams.get("state");
        const code = queryParams.get("code");
        const error = queryParams.get("error");

        if (!state) {
            this.sessionStorageService.set(ID_PROOFING_ERROR_STORAGE_KEY, "Identity verification validation has failed.");
            return;
        }

        try {
            await this.idProofingService.validateAsync({
                state,
                code: code ?? undefined,
                error: error ?? undefined
            });
            await this.sessionService.refreshProfile();
        } catch {
            this.sessionStorageService.set(ID_PROOFING_ERROR_STORAGE_KEY, "Identity verification validation has failed.");
        }
    }
}
